// src/core/constants.ts

/** 技能分类中文标签 */
export const CATEGORY_LABEL: Record<string, string> = {
  physical: '物理',
  special: '魔法',
  status: '变化',
};

/** 技能分类颜色样式 */
export const CATEGORY_COLOR: Record<string, string> = {
  physical: 'bg-red-500/20 text-red-400 border-red-500/40',
  special: 'bg-blue-500/20 text-blue-400 border-blue-500/40',
  status: 'bg-slate-500/20 text-slate-400 border-slate-500/40',
};